import BookGrid from "./book-grid.component";

export default BookGrid;
